module.exports = ":host {\n    display: block;\n    padding: 10px;\n}\n\n.leftPanel, .rightPanel{\n    border: 0.5px solid #3333334d;\n    /* margin: 20px; */\n    padding: 0 20px;\n}\n\n.rightPanel {\n    padding: 0 10px;\n}\n\nul, p{\n    margin-bottom: 0px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/course-details/course-details.component.css
// module id = ./src/app/course-details/course-details.component.css
// module chunks = main